import quadrants from './quadrants'
import snippets  from './snippets'
import anchors   from './anchors'
import phrases   from './phrases'
import axios from 'axios'

async function get( url ) {
  return await axios.get( url )
}

export default {
  get,
  quadrants,
  snippets,
  anchors,
  phrases,
}
